import { CaretRightOutlined, PauseOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../Components/Button"
import Icon from "../../../../Icon"

/**
 * Trial's MapControls: one glass surface pinned to the globe's top-right corner, stacked
 * vertically. Order follows Trial: play/pause, reset, zoom out, zoom in. The pause and play
 * glyphs come from @ant-design/icons, which the app already uses, because the SVG registry has
 * no pause icon and adding one is not ours to do.
 *
 * Mobile has no overlay to pin to (the globe is much shorter there), so the caller renders
 * this below the globe instead of inside it - `isMobile` switches it from that one glass pill
 * to a row of separate bordered buttons, order reversed (zoom in, zoom out, reset, pause).
 */
const GlobeControls = ({
  onZoomIn,
  onZoomOut,
  onReset,
  onToggleAutoSpin,
  canZoomIn,
  canZoomOut,
  canReset,
  isAutoSpinning,
  isMobile
}) => {
  const { t } = useTranslation()

  const toggleBtn = (
    <ButtonComponent
      type="text"
      className="globe-controls_btn"
      aria-label={isAutoSpinning ? t("Pause rotation") : t("Resume rotation")}
      icon={isAutoSpinning ? <PauseOutlined /> : <CaretRightOutlined />}
      onClick={onToggleAutoSpin}
    />
  )
  const resetBtn = (
    <ButtonComponent
      type="text"
      className="globe-controls_btn"
      aria-label={t("Reset view")}
      icon={<Icon type="arrow_rotate" />}
      disabled={!canReset}
      onClick={onReset}
    />
  )
  const zoomOutBtn = (
    <ButtonComponent
      type="text"
      className="globe-controls_btn"
      aria-label={t("Zoom out")}
      icon={<Icon type="minus" />}
      disabled={!canZoomOut}
      onClick={onZoomOut}
    />
  )
  const zoomInBtn = (
    <ButtonComponent
      type="text"
      className="globe-controls_btn"
      aria-label={t("Zoom in")}
      icon={<Icon type="plus" />}
      disabled={!canZoomIn}
      onClick={onZoomIn}
    />
  )

  if (isMobile) {
    return (
      <div className="globe-controls-mobile">
        {zoomInBtn}
        {zoomOutBtn}
        {resetBtn}
        {toggleBtn}
      </div>
    )
  }

  return (
    <div className="globe-controls">
      {toggleBtn}
      <span className="globe-controls_divider" aria-hidden="true" />
      {resetBtn}
      <span className="globe-controls_divider" aria-hidden="true" />
      {zoomOutBtn}
      <span className="globe-controls_divider" aria-hidden="true" />
      {zoomInBtn}
    </div>
  )
}

export default GlobeControls
